// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/images/dynamik-logo.png", import.meta.url);
// Module
var code = `<template>
  <require from="elements/selects/main-customer-lookup/main-customer-lookup"></require>
  <require from="elements/navigation/urlNavigation"></require>
  <require from="elements/date/datePicker"></require>
  <require from="perfect-scrollbar/css/perfect-scrollbar.css"></require>
  <require from="./notifications-list/notifications-list"></require>

  <global-progress show.bind="busy" ref="progress" mdc-focus-trap mdc-focus-trap.ref="progressFocusTrap" progress.bind="progressNumber" text.bind="progressText"></global-progress>

  <mdc-top-app-bar fixed dense if.bind="!isEulaRoute">
    <mdc-top-app-bar-row>
      <mdc-top-app-bar-section>
        <button mdc-top-app-bar-nav-icon click.delegate="toggleMainMenu()" class="mdc-top-app-bar-nav-icon">
          <mdc-icon>menu</mdc-icon>
        </button>
        <mdc-top-app-bar-title>
          <a href="home" class="top-bar-logo"><img src="${___HTML_LOADER_IMPORT_0___}" alt="Dynamik"></a>
        </mdc-top-app-bar-title>
      </mdc-top-app-bar-section>
      <mdc-top-app-bar-section end>
        <mdc-daterange-picker label="Date range" class="report-daterange-filter mdc-daterange-picker--dense" inputmask-format="99.99.9999 - 99.99.9999" format="dd.MM.yyyy" value.bind="customerSettings.dateRange">
        </mdc-daterange-picker>
        <main-customer-lookup value.two-way="selectedCustomer" hide-header="true" class="dynamik-input--md-lookup" goto-settings.delegate="gotoSettings()"></main-customer-lookup>
        <mdc-icon ref="dashboardMenuAnchor" mdc-top-app-bar-action-item click.trigger="dashboardMenu.toggle()" if.bind="dashboardMenu">dashboard</mdc-icon>
        <baloon value.bind="notificationAlertCount">
          <mdc-icon ref="notificationsIcon" mdc-top-app-bar-action-item click.trigger="notificationsDrawer.open = !notificationsDrawer.open">
            notifications</mdc-icon>
        </baloon>
        <mdc-icon ref="accountMenuAnchor" mdc-top-app-bar-action-item click.trigger="accountMenu.toggle()">account_box
        </mdc-icon>
        <a mdc-icon-button href="https://hjelp.dynamik.no/portal/nb/kb/dynamik" icon="help" target="_blank" title="Help"></a>
      </mdc-top-app-bar-section>
    </mdc-top-app-bar-row>
  </mdc-top-app-bar>
  <mdc-drawer type="dismissible" view-model.ref="mainMenu" mdc-top-app-bar-fixed-adjust="dense" if.bind="!isEulaRoute" class="main-menu-drawer \${mainMenuIconsOnly ? 'mdc-drawer--icons-only' : ''} \${bannerOpen ? 'mdc-drawer--banner-open' : ''}">
    <mdc-drawer-content perfect-scrollbar>
      <mdc-deprecated-list activated wrap-focus tabindex="0">
        <template repeat.for="mi of menu">
          <div if.bind="!mi.children">
            <a mdc-deprecated-list-item route-href="route.bind: mi.route; params.bind: mi.routeParams" title="\${mi.title || mi.text}" activated.bind="router.currentInstruction.config.name === mi.route" disabled.bind="mi.disabled">
              <mdc-icon mdc-deprecated-list-item-graphic class="compound-icon">\${mi.icon}<span class="mdc-theme--primary" if.bind="mi.secondaryIcon">\${mi.secondaryIcon}</span></mdc-icon>
              <span>\${mi.text}</span>
            </a>
          </div>
          <div if.bind="mi.children" class="\${mi === expandedMenuItem ? 'expanded-menu-item' : ''}">
            <mdc-deprecated-list-item click.trigger="toggleRootMenuItem(mi)" ref="rootMenuItem" title="\${mi.title || mi.text}" pointerenter.trigger="handleMenuItemPointerEnter(mi, subMenu)" pointerleave.trigger="handleMenuItemPointerLeave(mi, subMenu, \$event)">
              <mdc-icon mdc-deprecated-list-item-graphic class="compound-icon">\${mi.icon}<span class="mdc-theme--primary" if.bind="mi.secondaryIcon">\${mi.secondaryIcon}</span></mdc-icon>
              <span>\${mi.text}</span>
              <mdc-menu view-model.ref="subMenu" anchor.bind="rootMenuItem" hoist-to-body anchor-corner="TOP_RIGHT" pointerleave.trigger="handleSubMenuPointerLeave(rootMenuItem, subMenu, \$event)" perfect-scrollbar>
                <mdc-list activated>
                  <a mdc-list-item repeat.for="cmi of mi.children" activated.bind="cmi.route === router.currentInstruction.config.name && (!cmi.routeParams || cmi.routeParams.subRoute == router.currentInstruction.params.subRoute)" route-href="route.bind: cmi.route; params.bind: cmi.routeParams">
                    <mdc-icon mdc-list-item-leading class="compound-icon">\${cmi.icon}<span class="mdc-theme--primary" if.bind="cmi.secondaryIcon">\${cmi.secondaryIcon}</span></mdc-icon>
                    \${cmi.text}
                  </a>
                </mdc-list>
              </mdc-menu>
            </mdc-deprecated-list-item>

            <div if.bind="mi === expandedMenuItem" class="children-menu-items">
              <a mdc-deprecated-list-item repeat.for="cmi of mi.children" route-href="route.bind: cmi.route; params.bind: cmi.routeParams" title="\${cmi.title || cmi.text}" activated.bind="router.currentInstruction.config.name === cmi.route && (!cmi.routeParams || cmi.routeParams.subRoute === router.currentInstruction.params.subRoute)">
                <mdc-icon mdc-deprecated-list-item-graphic class="compound-icon">\${cmi.icon}<span class="mdc-theme--primary" if.bind="cmi.secondaryIcon">\${cmi.secondaryIcon}</span></mdc-icon>
                <span>\${cmi.text}</span>
              </a>
            </div>

          </div>
        </template>
      </mdc-deprecated-list>
    </mdc-drawer-content>
    <div mdc-ripple class="hide-text-icon" click.delegate="toggleMainMenuIconsOnly()">
      <mdc-icon>\${mainMenuIconsOnly ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left'}</mdc-icon>
    </div>
  </mdc-drawer>
  <router-view mdc-top-app-bar-fixed-adjust="dense" class="main-section app-grid mdc-drawer-app-content \${notificationsDrawerOpen ? 'mdc-drawer-app-content--notifications-drawer-open' : ''} \${mainMenuIconsOnly ? 'mdc-drawer-app-content--narrow' : ''} \${bannerOpen ? 'mdc-drawer-app-content--banner-open' : ''}" perfect-scrollbar>
  </router-view>
  <mdc-drawer type="dismissible" view-model.ref="notificationsDrawer" dir="rtl" class="notifications-drawer \${bannerOpen ? 'mdc-drawer--banner-open' : ''}" mdc-top-app-bar-fixed-adjust="dense" mdcdrawer:opened.trigger="handleNotificationsDrawerEvent()" mdcdrawer:closed.trigger="handleNotificationsDrawerEvent()">
    <mdc-drawer-header dir="ltr">
      <h3 class="mdc-drawer__title">
        <span>Notifications</span>
        <button mdc-icon-button icon="close" click.trigger="notificationsDrawer.open = false"></button>
      </h3>
    </mdc-drawer-header>
    <mdc-drawer-content dir="ltr">
      <notifications-list view-model.ref="notificationsList"></notifications-list>
    </mdc-drawer-content>
  </mdc-drawer>

  <mdc-menu view-model.ref="accountMenu" mdcmenu:selected.trigger="onMenuSelect(\$event.detail.data)" anchor.bind="accountMenuAnchor" anchor-corner="BOTTOM_LEFT">
    <mdc-list wrap-focus.bind="wrapFocus" tabindex="-1">
      <a mdc-list-item>
        <mdc-icon mdc-list-item-leading>person</mdc-icon>
        <span>\${user.email}</span>
      </a>
      <a mdc-list-item if.bind="selectedCustomer.voucherReceivingEmail" href="mailto:\${selectedCustomer.voucherReceivingEmail}">
        <mdc-icon mdc-list-item-leading>forward_to_inbox</mdc-icon>
        <span>Email us</span>
      </a>
      <a mdc-list-item no-list-action mdclistitem:action.trigger="getExcelToken()">
        <mdc-icon mdc-list-item-leading>table_chart</mdc-icon>
        <span>Get Excel token</span>
      </a>
      <mdc-list-item click.trigger="themeService.loadTheme(!themeService.darkTheme) & stopPropagation">
        <mdc-icon mdc-list-item-leading>\${themeService.darkTheme ? 'light_mode' : 'dark_mode'}</mdc-icon>
        \${themeService.darkTheme ? 'Light' : 'Dark'} mode
      </mdc-list-item>
      <mdc-list-item value="logout">
        <mdc-icon mdc-list-item-leading>logout</mdc-icon>
        <span>Logout</span>
      </mdc-list-item>
    </mdc-list>
  </mdc-menu>
  <mdc-menu anchor.bind="themeMenuItem" view-model.ref="themeMenu" hoist-to-body anchor-corner="TOP_RIGHT" mdcmenu:selected.trigger="themeService.loadTheme(\$event.detail.data)">
    <mdc-list tabindex="-1">
      <mdc-list-item value="default">
        <mdc-icon mdc-list-item-leading>\${themeService.currentTheme === 'default' ? 'done' : ''}</mdc-icon>
        Default
      </mdc-list-item>
      <mdc-list-item value="light">
        <mdc-icon mdc-list-item-leading>\${themeService.currentTheme === 'light' ? 'done' : ''}</mdc-icon>
        Light
      </mdc-list-item>
      <mdc-list-item value="dark">
        <mdc-icon mdc-list-item-leading>\${themeService.currentTheme === 'dark' ? 'done' : ''}</mdc-icon>
        Dark
      </mdc-list-item>
    </mdc-list>
  </mdc-menu>

  <div ref="customerService.excelExportMenuAnchor" style="position: fixed;"></div>
  <mdc-menu hoist-to-body anchor.bind="customerService.excelExportMenuAnchor" anchor-corner="BOTTOM_LEFT" mdcmenu:selected.trigger="customerService.exportWidget()" view-model.ref="customerService.exportMenu">
    <mdc-list tabindex="-1">
      <mdc-list-item>
        <mdc-icon mdc-list-item-leading>bar_chart</mdc-icon> Export to Excel
      </mdc-list-item>
    </mdc-list>
  </mdc-menu>

</template>
`;
// Exports
export default code;